import {
    EDIT_SUBMISSION,
    SUBMISSION_STATUS,
    CHANGE_SUBMISSION_STATUS,
    CHANGE_SUBMISSION,
    CHANGE_FEES_COVERAGES_MULTI,
    CLEAR_SUBMISSION,
    SUBMISSION_EXCESS_SELECTION,
    SUBMISSION_CREATE_SUCCESS,
    CHANGE_SUBMISSION_COVERAGE,
    CHANGE_SUBMISSION_RELATED_ENTITIES,
    SET_SUBMISSION_DIALOG_STATUS,
    SUBMISSION_DIALOG_STATUS,
    SET_SUBMISSION_AND_DIALOG_STATUS,
    SUBMISSION_SET_PRICING_MANUALLY,
    SUBMISSION_CHANGE_PRICING_VALUE,
    SUBMISSION_LIMIT_CHANGE,
    SUBMISSION_ADJUSTED_COMMISSION_CHANGE,
    SUBMISSION_UPDATE_WORKFLOW_STATUS_CHANGE,
    SUBMISSION_UPDATE_WORKFLOW_LIMIT_CHANGE,
    SUBMISSION_UPDATE_WORKFLOW_COVERAGE_CHANGE,
    SUBMISSION_UPDATE_WORKFLOW_INCLUDED_CHANGE,
    SUBMISSION_UPDATE_BIND_STATUS_CHANGE,
    SUBMISSION_SET_ISBINDED,
    SUBMISSION_SET_ISBINDERSAVED,
    CHANGE_AI_FORMS,
    CHANGE_AI_LIST,
    GET_PDF_ARRAY,
    SUBMISSION_UPDATE_RATING_OPTION,
    SUBMISSION_UPDATE_ADDL_DOCS_ID,
    SUBMISSION_UPDATE_IS_EXCESS_ONLY,
    SUBMISSION_UPDATE_MANUAL_QUOTE_STATUS_FOR_ID,
    SUBMISSIONS_UPDATE_DATA_ARRAY,
    SUBMISSION_UPDATE_BY_KEY,
    LOAD_ARGOPI,
    LOAD_ARGOPI_FAILURE,
    LOAD_ARGOPI_SUCCESS,
    LOAD_ARGOPI_RESET,
    SUBMISSION_UPSELL,
    SUBMISSION_UPSELL_SUCCESS,
    SUBMISSION_UPSELL_FAILURE,
    SUBMISSION_UPSELL_RESET,
    SUBMISSION_UPDATE_WITH_EDGE_NUMBER,
    SUBMISSION_UPDATE_WITH_EDGE_NUMBER_SUCCESS,
    SUBMISSION_UPDATE_WITH_EDGE_NUMBER_FAILURE,
    SUBMISSION_UPDATE_WITH_EDGE_NUMBER_RESET,
} from './../constants/submission';

const initialState = {
    status: SUBMISSION_STATUS.NONE,
    submission: {},
    submissionFormParams: {},
    isBusy: false,
    error: false,
    inDialog: SUBMISSION_DIALOG_STATUS.NONE,
    workflowStatusChange: [],
    bindStatusChange: []
};

export default function(state = initialState, action) {
    switch (action.type) {
        case CHANGE_SUBMISSION:
            return Object.assign(state, {
                submission: Object.assign(
                    state.submission ? state.submission : {},
                    action.payload.submission
                ),
                submissionFormParams: action.payload.submissionFormParams
            });
        case CHANGE_SUBMISSION_STATUS:
            return Object.assign(state, {
                status: action.status
            });

        case SUBMISSION_CREATE_SUCCESS:
            return {
                ...state,
                submission: {
                    ...state.submission,
                    ...action.value.submission
                }
            };

        case CLEAR_SUBMISSION:
            return { ...state, submission: {}, submissionFormParams: {} };

        case SUBMISSION_EXCESS_SELECTION:
            return {
                ...state,
                submission: {
                    ...state.submission,
                    excessLimitAmount: action.value
                }
            };

        /**
         * Coverage can be changed in 2 ways: based coverage, additional coverage, optional coverage
         * or fee coverage
         * In both cases, we must create a copy of the state: immutability blah-blah-blah
         *
         * In case of "Base" coverage change is straightforward: simply update coverages.gl.base
         * In case of "Additional": we must check if we added or removed coverage.
         * In case of "Optional": we must check if we added or removed coverage.
         * In case of "Fee": we must check if we added or removed coverage.
         * In the first case we set selected as true. Otherwise: false
         */
        case CHANGE_SUBMISSION_COVERAGE:
            const coverages = { ...state.submission.coverages };
            if (!coverages.gl) {
                coverages.gl = {};
            }

            if (action.value.selectionType === 'Base') {
                coverages.gl.base = action.value.selectedValue;
                const submission = { ...state.submission, coverages: coverages };

                return Object.assign({}, state, { submission: submission });
            }

            if (action.value.selectionType === 'Additional') {
                const isSelected = action.value.selectionAction === 'Add' ? true : false;
                const additional = { ...coverages.gl.additional };
                additional[action.value.selectedValue] = { selected: isSelected };
                coverages.gl.additional = Object.assign({}, coverages.gl.additional, additional);
                const submission = Object.assign({}, state.submission, { coverages: coverages });

                return Object.assign({}, state, { submission: submission });
            }

            if (action.value.selectionType === 'Optional') {
                const isSelected = action.value.selectionAction === 'Add' ? true : false;
                const optional = { ...coverages.gl.optional };
                optional[action.value.selectedValue] = { selected: isSelected };
                coverages.gl.optional = Object.assign({}, coverages.gl.optional, optional);
                const submission = Object.assign({}, state.submission, { coverages: coverages });

                return Object.assign({}, state, { submission: submission });
            }

            if (action.value.selectionType === 'Fees') {
                const isSelected = action.value.selectionAction === 'Add' ? true : false;
                const fees = { ...coverages.gl.fees };
                if (fees && Object.hasOwn(fees, action.value.selectedValue)) {
                    fees[action.value.selectedValue] = { selected: isSelected };
                    coverages.gl.fees = Object.assign({}, coverages.gl.fees, fees);
                }
                const submission = Object.assign({}, state.submission, { coverages: coverages });

                return Object.assign({}, state, { submission: submission });
            }

            return state;
        case CHANGE_SUBMISSION_RELATED_ENTITIES:
            const submission = { ...state.submission };
            const { relatedEntities = {} } = submission;
            submission.relatedEntities = Object.assign(relatedEntities, action.value);
            return Object.assign(state, { submission });
        case SET_SUBMISSION_DIALOG_STATUS:
            const value = action.value;
            return { ...state, inDialog: value };
        case SET_SUBMISSION_AND_DIALOG_STATUS:
            return {
                ...state,
                isBusy: false,
                error: false,
                inDialog: SUBMISSION_DIALOG_STATUS.NONE
            };
        case SUBMISSION_LIMIT_CHANGE:
            return {
                ...state,
                submission: {
                    ...state.submission,
                    limitsRequested: action.value
                }
            };
        case SUBMISSION_ADJUSTED_COMMISSION_CHANGE:
            return {
                ...state,
                submission: {
                    ...state.submission,
                    adjustedCommission: action.value.adjustedCommission,
                    totalAdjustedCommission: action.value.totalAdjustedCommission,
                }
            };
        case SUBMISSION_SET_PRICING_MANUALLY:
            return {
                ...state,
                submission: {
                    ...state.submission,
                    manuallySetPricing: action.payload.manuallySetPricing.toString()
                }
            };
        case SUBMISSION_SET_ISBINDED:
            return {
                ...state,
                submission: {
                    ...state.submission,
                    isBinded: action.payload.isBinded
                }
            };
        case SUBMISSION_SET_ISBINDERSAVED:
            return {
                ...state,
                submission: {
                    ...state.submission,
                    isBinderSaved: action.payload.isBinderSaved,
                    binderData: action.payload.binderData
                }
            };
        case SUBMISSION_CHANGE_PRICING_VALUE:
            const { type, ratings = { [type]: {} } } = state.submission;
            Object.assign(ratings[type], action.payload);
            return {
                ...state,
                submission: {
                    ...state.submission,
                    ratings
                }
            };
        case SUBMISSION_UPDATE_WORKFLOW_STATUS_CHANGE:
            const { id, workflowStatus } = action.payload;
            const { workflowStatusChange = [] } = state;
            const index = workflowStatusChange.findIndex(item => item.id === id);

            if (index < 0) {
                workflowStatusChange.push({ id, workflowStatus });
            } else {
                workflowStatusChange[index] = { id, workflowStatus };
            }
            return {
                ...state,
                workflowStatusChange
            };
        case SUBMISSION_UPDATE_WORKFLOW_LIMIT_CHANGE:
            return {
                ...state,
                submission: {
                    ...state.submission,
                    isMinPremiumRequested: action.value,
                    isMinPremium: action.value
                }
            };
        case SUBMISSION_UPDATE_WORKFLOW_COVERAGE_CHANGE:
            return {
                ...state,
                submission: {
                    ...state.submission,
                    isPCOpsExcluded: action.value,
                    isESWorkExcluded: action.value
                }
            };
        case SUBMISSION_UPDATE_WORKFLOW_INCLUDED_CHANGE:
            return {
                ...state,
                submission: {
                    ...state.submission,
                    included: action.value
                }
            };
        case SUBMISSION_UPDATE_BIND_STATUS_CHANGE:
            const { isBinded } = action.payload;
            const { isBinderSaved } = action.payload;
            const bindedSubmissionId = action.payload.id;
            const { bindStatusChange = [] } = state;
            const bindIndex = bindStatusChange.findIndex(item => item.id === bindedSubmissionId);

            if (bindIndex < 0) {
                bindStatusChange.push({ id: bindedSubmissionId, isBinded, isBinderSaved });
            } else {
                bindStatusChange[bindIndex] = { id: bindedSubmissionId, isBinded, isBinderSaved };
            }
            return {
                ...state,
                bindStatusChange
            };
        case CHANGE_AI_FORMS:
            const { additionalInsuredArray, formValues, numberOfAIForms } = action.payload;
            if (action.payload.index === 0) {
                const submission = {
                    ...state.submission,
                    additionalInsuredArray: additionalInsuredArray,
                    additionalInsuredForms: formValues,
                    numberOfAIForms
                };
                return Object.assign({}, state, { submission: submission });
            } else if (action.payload.index === 1) {
                const submission = {
                    ...state.submission,
                    additionalInsuredArray: additionalInsuredArray,
                    secondAdditionalInsuredForms: formValues,
                    numberOfAIForms
                };
                return Object.assign({}, state, { submission: submission });
            } else if (action.payload.index === 2) {
                const submission = {
                    ...state.submission,
                    additionalInsuredArray: additionalInsuredArray,
                    thirdAdditionalInsuredForms: formValues,
                    numberOfAIForms
                };
                return Object.assign({}, state, { submission: submission });
            } else {
                return state;
            }

        case CHANGE_AI_LIST:
            return {
                ...state,
                submission: {
                    ...state.submission,
                    additionalInsuredArray: action.payload.additionalInsuredArray,
                    numberOfInsureds: action.payload.numberOfInsureds
                }
            };
        case GET_PDF_ARRAY:
            const PDFdata = action.payload.data;
            const pdfStatus = action.payload.pdfStatus;
            return {
                ...state,
                PDFdata,
                pdfStatus
            };
        case SUBMISSION_UPDATE_RATING_OPTION:
            return {
                ...state,
                submission: {
                    ...state.submission,
                    ratings: {
                        ...state.submission.ratings,
                        options: {
                            ...state.submission.ratings.options,
                            ...action.payload
                        }
                    }
                }
            };
        case SUBMISSION_UPDATE_ADDL_DOCS_ID:
            return {
                ...state,
                submission: {
                    ...state.submission,
                    additionalDocumentsId: action.payload
                }
            };
        case SUBMISSION_UPDATE_IS_EXCESS_ONLY:
            return {
                ...state,
                submission: {
                    ...state.submission,
                    isExcessOnly: action.payload
                }
            };
        case SUBMISSION_UPDATE_MANUAL_QUOTE_STATUS_FOR_ID:
            const { submissionDataUpdatedFromModalArray = [] } = state;
            let existingEntryFound = false;
            const submissionDataUpdatedFromModalArrayCopy = submissionDataUpdatedFromModalArray.map(item => {
                if (item.id === action.payload.id) {
                    existingEntryFound = true;
                    return {
                        ...item,
                        status: action.payload.status,
                        primaryPolicyNumber: action.payload.primaryPolicyNumber
                    }
                }
                return {...item};
            })
            if (!existingEntryFound) {
                submissionDataUpdatedFromModalArrayCopy.push(action.payload);
            }
            return {
                ...state,
                submissionDataUpdatedFromModalArray: submissionDataUpdatedFromModalArrayCopy
            };

        /**
         * When updating data on the main submissions grid page from a modal popup, sometimes
         * the UI renders before Elastic Search is updated so the grid may not contain the lastest
         * data. You can call the updateDataFromModalArray action to trigger the
         * SUBMISSIONS_UPDATE_DATA_ARRAY case and populate the submissionDataUpdatedFromModalArray
         * with the data you need populated in the submission grid UI as this case it meant to
         * be generic.
         */
        case SUBMISSIONS_UPDATE_DATA_ARRAY:
            const { submissionDataUpdatedFromModalArray: submissionDataArray = [] } = state;
            let entryFound = false;
            const submissionDataArrayCopy = submissionDataArray.map(item => {
                if (item.id === action.payload.id) {
                    entryFound = true;
                    return {
                        ...item,
                        ...action.payload.data
                    }
                }
                return { ...item };
            })
            if (!entryFound) {
                submissionDataArrayCopy.push({
                    id: action.payload.id,
                    ...action.payload.data
                });
            }
            return {
                ...state,
                submissionDataUpdatedFromModalArray: submissionDataArrayCopy
            };

        case SUBMISSION_UPDATE_BY_KEY:
            // Generic case to update top level submission key with a value
            return {
                ...state,
                submission: {
                    ...state.submission,
                    [action.payload.key]: action.payload.value
                }
            };
        case LOAD_ARGOPI:
            return {
                ...state,
                argopiLoaded: true,
                argopiSuccess: false,
                argopiFailed: false,
                submission: action.payload
            }
        case LOAD_ARGOPI_FAILURE:
            return {
                ...state,
                argopiFailed: true,
                argopiLoaded: false,
            }
        case LOAD_ARGOPI_SUCCESS:
            return {
                ...state,
                argopiSuccess: true,
                argopiResp: action.payload.body.ioResponse,
                argopiLoaded: false,
                submission: {
                    ...action.payload.body.data
                }
            }
        case LOAD_ARGOPI_RESET:
            return {
                ...state,
                argopiSuccess: undefined,
                argopiResp: undefined,
                argopiLoaded: undefined,
                argopiFailed: undefined,
            }
        case SUBMISSION_UPSELL:
            return {
                ...state,
                upsellIsBusy: true,
                upsellSuccess: false,
                upsellFailed: false,
            };
        case SUBMISSION_UPSELL_SUCCESS:
            return {
                ...state,
                upsellIsBusy: false,
                upsellSuccess: true,
                upsellFailed: false,
            };
        case SUBMISSION_UPSELL_FAILURE:
            return {
                ...state,
                upsellIsBusy: false,
                upsellSuccess: false,
                upsellFailed: true,
            };
        case SUBMISSION_UPSELL_RESET:
            return {
                ...state,
                upsellIsBusy: undefined,
                upsellSuccess: undefined,
                upsellFailed: undefined,
            };
        case SUBMISSION_UPDATE_WITH_EDGE_NUMBER:
            return {
                ...state,
                updateEdgeNumberIsBusy: true,
                updateEdgeNumberSuccess: false,
                updateEdgeNumberFailure: false,
            };
        case SUBMISSION_UPDATE_WITH_EDGE_NUMBER_SUCCESS:
            return {
                ...state,
                updateEdgeNumberIsBusy: false,
                updateEdgeNumberSuccess: true,
                updateEdgeNumberFailure: false,
            };
        case SUBMISSION_UPDATE_WITH_EDGE_NUMBER_FAILURE:
            return {
                ...state,
                updateEdgeNumberIsBusy: false,
                updateEdgeNumberSuccess: false,
                updateEdgeNumberFailure: true,
            };
        case SUBMISSION_UPDATE_WITH_EDGE_NUMBER_RESET:
            return {
                ...state,
                updateEdgeNumberIsBusy: null,
                updateEdgeNumberSuccess: null,
                updateEdgeNumberFailure: null,
            };
        case CHANGE_FEES_COVERAGES_MULTI:
            return {
                ...state,
                submission: {
                    ...state.submission,
                    coverages: {
                        ...state.submission.coverages,
                        gl: {
                            ...state.submission.coverages?.gl,
                            fees: {
                                ...action.payload
                            }
                        }
                    }
                }
            };
        default:
            return state;
    }
}
